import { DateTime } from 'luxon'
import { size } from 'lodash-es'
import { toOrgUserTags } from '../../../api/common/sharedUtils.js'

export function requiredScreenerIsActiveForUser({ orgId, userProfile, requiredScreener, now }) {
    const { screenerId, startDate, endDate, userTags } = requiredScreener
    const start = DateTime.fromFormat(startDate, 'yyyy-MM-dd')
    const end = DateTime.fromFormat(endDate, 'yyyy-MM-dd')
    if (!screenerId || !start.isValid || !end.isValid || now < start || now >= end) return false
    if (!Array.isArray(userTags) || !userTags.length) return true
    const tags = Array.isArray(userProfile?.tags) ? userProfile.tags : []
    const orgUserTags = toOrgUserTags({ orgId, userTags: tags })
    return userTags.every(tag => orgUserTags.includes(tag) || tags.includes(tag))
}

function timeFragmentIsInRange({ timeFragment, startDate, endDate, now }) {
    let parsed = DateTime.fromFormat(timeFragment, 'yyyy-MM-dd')
    if (!parsed.isValid) {
        parsed = DateTime.fromFormat(timeFragment, 'yyyy-MM')
        if (parsed.year === now.year && parsed.month === now.month) parsed = parsed.set({ day: now.day })
    }
    return parsed.isValid && startDate <= parsed && parsed < endDate
}

export async function getPendingRequiredScreeners({ store, orgId, userProfile, requiredScreeners, now = DateTime.now() }) {
    const pending = []
    for (const requiredScreener of requiredScreeners || []) {
        if (!requiredScreenerIsActiveForUser({ orgId, userProfile, requiredScreener, now })) continue
        const { screenerId } = requiredScreener
        const startDate = DateTime.fromFormat(requiredScreener.startDate, 'yyyy-MM-dd')
        const endDate = DateTime.fromFormat(requiredScreener.endDate, 'yyyy-MM-dd')
        const screener = await store.getOrgScreener({ orgId, screenerId })
        const questionsSize = size(screener.formConfig.questions)
        await store.loadRecentScreenerAnswers({ orgId, screenerId })
        const results = await store.getRecentScreenerAnswers({ orgId, screenerId })
        const taken = (results || []).some(result =>
            result.timeFragment &&
            timeFragmentIsInRange({ timeFragment: result.timeFragment, startDate, endDate, now }) &&
            questionsSize === size(result.answers)
        )
        if (!taken) pending.push(screener)
    }
    return pending
}
